import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-enterprise';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';                             
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import moment from 'moment';
import AppConstants from 'src/app/shared/common-components/AppConstants';

@Component({
    selector: 'app-tspagy-profile-audit-trail',
    templateUrl: './tspagy-profile-audit-trail.component.html',
    styleUrls: ['./tspagy-profile-audit-trail.component.css'],
    standalone: false
})
export class TspAgyProfileAuditTrailComponent implements OnInit {

  orgId: any;
  orgUpdateForm: UntypedFormGroup;
  additionalMessageResponse: any;
  redirectedFromBol: any;
  profileName: any;
  currentMessage: any;
  messageArray = [];
  messages: any;
  audiTrailData: any;
  columnDefs: (ColDef | ColGroupDef)[];
  updateMessagesOptions: GridOptions = this.initializeGridOptions();
  rowData: any;
  public overlayNoRowsTemplate;
  private gridApi;

  constructor(private formBuilder: UntypedFormBuilder, 
    private alertService: AlertService,
    private tmssLoader: LoadingService,
    private route: ActivatedRoute,

    private bsModalRef: BsModalRef,
    public options: ModalOptions,
    ) {
      this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No rows to display, please adjust your filters</span>';
    this.orgUpdateForm = this.formBuilder.group({
      newMessage: new UntypedFormControl('')
    });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        flex: 1,
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: this.audiTrailData,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  /**
   * initializing the ag-grid
   * @param params
   */
   onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption('headerHeight', 30);
  }
    
  
  ngOnInit() {

    this.audiTrailData = this.options.initialState;
    this.rowData = this.audiTrailData.auditTrailLogList;
    this.updateColumnDefs();
    this.profileName = this.audiTrailData.profile;  
    this.tmssLoader.hide(); 
  }


 updateColumnDefs() {
  this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
}

getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
  return [
    <ColDef>
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        autoHeight: true,
        headerName: 'Field Name',
        field: 'fieldName',
        filter: 'agTextColumnFilter', 
        sortable: true
       
      },
      {
        flex: 1,
        cellDataType: 'text',
        resizable: true,
        wrapText: true,
        headerName: 'Old Value',
        field: 'oldValue',        
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        flex: 1,
         cellDataType: 'text',
        resizable: true,
        wrapText: true,
        headerName: 'New Value',
        field: 'newValue',
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Update Date',
        cellRenderer: (params: any) => {
          const dataTime = new Date(params.data.updateDate);
          return (AppConstants.isNotNullCondition(dataTime)) ? moment(dataTime).format("YYYY-MM-DD HH:mm:ss") : '';
        },
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Updated By',
        field: 'updateEmailAddress',
        filter: 'agTextColumnFilter', 
        sortable: true
      }
    ];
}

  loadMessageHistory(existingMessages) {
    /* for(let i = 0; i<existingMessages.length(); i++) {
      this.messageHistoryArray[i] = existingMessages[i].message;
    } */
  }

  /**
   * @description cancel message entered
   */
  cancelMessage() {
    // this.bsModalRef.hide();
  }

  closeModal() {
    this.bsModalRef.hide();

  }


}